import { createKitRequestLineFormConstants } from 'views/kitting/Kit/components/constants';
import { HookFormInput } from 'ui-component/HookFormComponents';
import { useFormContext, useWatch } from 'react-hook-form';
import { CustomProperty } from 'types/customProperty';
import _ from 'lodash';
import { HookFormCustomPropertyInput } from 'ui-component/HookFormComponents/HookFormCustomPropertyInput';
import { Stack } from '@mui/system';
import PartV2Picker from 'ui-component/PartV2Picker';
import { Box } from '@mui/material';
import { OrgPartType } from 'types/clientV2/parts';
import { useFeature } from '@growthbook/growthbook-react';
import { FeatureFlags } from 'types';
import { HookFormUnitOfMeasureAutocomplete } from 'ui-component/HookFormComponents/HookFormUnitOfMeasureAutocomplete';

const CreateKitRequestFromPart = ({
  customProperties,
}: {
  customProperties?: CustomProperty[];
}) => {
  const tempUoM = useFeature(FeatureFlags.tempUoM).on;
  const {
    control,
    formState: { errors },
    setValue,
    register,
  } = useFormContext();

  const watchDimensionClass = useWatch({
    control,
    name: createKitRequestLineFormConstants.dimensionClassPart.id,
  });

  return (
    <>
      <Box sx={{ mb: 2 }}>
        <PartV2Picker
          onChange={(parts) => {
            setValue(
              createKitRequestLineFormConstants.v2OrgPart.id,
              parts?.[0]?.id ?? '',
              {
                shouldValidate: true,
              }
            );
            setValue(
              createKitRequestLineFormConstants.dimensionClassPart.id,
              parts?.[0]?.dimensionClass ?? '',
              {
                shouldValidate: true,
              }
            );
            if (parts?.[0]?.preferredUnit) {
              setValue(
                createKitRequestLineFormConstants.dimensionUnitPart.id,
                parts?.[0]?.preferredUnit ?? '',
                {
                  shouldValidate: true,
                }
              );
            }
          }}
          errors={errors}
          name={createKitRequestLineFormConstants.v2OrgPart.id}
          partTypesToIgnore={[OrgPartType.NON_STOCKED, OrgPartType.SERVICE]}
        />
      </Box>
      {tempUoM ? (
        <Stack direction="row" spacing={2}>
          <HookFormInput
            control={control}
            name={createKitRequestLineFormConstants.targetDimensionValuePart.id}
            label={
              createKitRequestLineFormConstants.targetDimensionValuePart.label
            }
            type="number"
            errors={errors}
            sx={{ flex: 1 }}
            boxSx={{ flex: 1 }}
          />
          <HookFormUnitOfMeasureAutocomplete
            control={control}
            name={createKitRequestLineFormConstants.dimensionUnitPart.id}
            label={createKitRequestLineFormConstants.dimensionUnitPart.label}
            errors={errors}
            limitToDimensionClass={watchDimensionClass}
          />
          <input
            type="hidden"
            {...register(
              createKitRequestLineFormConstants.dimensionClassPart.id
            )}
          />
        </Stack>
      ) : (
        <HookFormInput
          control={control}
          name={createKitRequestLineFormConstants.targetQuantityPart.id}
          label={createKitRequestLineFormConstants.targetQuantityPart.label}
          type="number"
          errors={errors}
        />
      )}
      {customProperties && (
        <Stack sx={{ mt: 2 }}>
          {_.map(customProperties, (property) => (
            <HookFormCustomPropertyInput
              control={control}
              errors={errors}
              key={property.key}
              customProperty={property}
              setValue={setValue}
            />
          ))}
        </Stack>
      )}
    </>
  );
};

export default CreateKitRequestFromPart;
